import React from 'react';
import {Navigate, Outlet} from "react-router-dom";
import {useSession} from 'providers/UseSession';

const PrivateRoute: React.FC = () => {
    const {isAuth, isActive} = useSession();
    return isAuth && isActive ? <Outlet/> : <Navigate to={'/login'}/>;
    // return  <Outlet/>
};

export default PrivateRoute;